import React from 'react';
import { Input, Button, Checkbox } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface QueryParamsProps {
  supplierFrom: string;
  supplierTo: string;
  yearMonFrom: string;
  yearMonTo: string;
  deptFrom: string;
  deptTo: string;
  buyerFrom: string;
  buyerTo: string;
  check1: boolean;
  check2: boolean;
  loading: boolean;
  onSupplierFromChange: (v: string) => void;
  onSupplierToChange: (v: string) => void;
  onYearMonFromChange: (v: string) => void;
  onYearMonToChange: (v: string) => void;
  onDeptFromChange: (v: string) => void;
  onDeptToChange: (v: string) => void;
  onBuyerFromChange: (v: string) => void;
  onBuyerToChange: (v: string) => void;
  onCheck1Change: (v: boolean) => void;
  onCheck2Change: (v: boolean) => void;
  onQuery: () => void;
}

const QueryParams: React.FC<QueryParamsProps> = ({
  supplierFrom, supplierTo, yearMonFrom, yearMonTo,
  deptFrom, deptTo, buyerFrom, buyerTo,
  check1, check2, loading,
  onSupplierFromChange, onSupplierToChange,
  onYearMonFromChange, onYearMonToChange,
  onDeptFromChange, onDeptToChange,
  onBuyerFromChange, onBuyerToChange,
  onCheck1Change, onCheck2Change,
  onQuery,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      {/* Row 1: Supplier code range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>廠商代號:[從]</span>
          <Input
            value={supplierFrom}
            onChange={(e) => onSupplierFromChange(e.target.value)}
            placeholder="起"
            style={{ width: 140 }}
            maxLength={12}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={supplierTo}
            onChange={(e) => onSupplierToChange(e.target.value)}
            placeholder="迄"
            style={{ width: 140 }}
            maxLength={12}
          />
        </div>
      </div>

      {/* Row 2: Year-month range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>年度月份:[從]</span>
          <Input
            value={yearMonFrom}
            onChange={(e) => onYearMonFromChange(e.target.value)}
            placeholder="YYYY/MM"
            style={{ width: 140 }}
            maxLength={7}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={yearMonTo}
            onChange={(e) => onYearMonToChange(e.target.value)}
            placeholder="YYYY/MM"
            style={{ width: 140 }}
            maxLength={7}
          />
        </div>
      </div>

      {/* Row 3: Department code range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>部門代號:[從]</span>
          <Input
            value={deptFrom}
            onChange={(e) => onDeptFromChange(e.target.value)}
            placeholder="起"
            style={{ width: 100 }}
            maxLength={4}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={deptTo}
            onChange={(e) => onDeptToChange(e.target.value)}
            placeholder="迄"
            style={{ width: 100 }}
            maxLength={4}
          />
        </div>
      </div>

      {/* Row 4: Buyer/purchaser range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>採購人員:[從]</span>
          <Input
            value={buyerFrom}
            onChange={(e) => onBuyerFromChange(e.target.value)}
            placeholder="起"
            style={{ width: 120 }}
            maxLength={8}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={buyerTo}
            onChange={(e) => onBuyerToChange(e.target.value)}
            placeholder="迄"
            style={{ width: 120 }}
            maxLength={8}
          />
        </div>
      </div>

      {/* Row 5: Print selection checkboxes */}
      <div className="flex flex-wrap items-center gap-6 mb-3 border border-gray-300 rounded p-3">
        <span className="text-sm font-medium">印表選擇</span>
        <Checkbox checked={check1} onChange={(e) => onCheck1Change(e.target.checked)}>
          部門廠商別
        </Checkbox>
        <Checkbox checked={check2} onChange={(e) => onCheck2Change(e.target.checked)}>
          廠商部門別
        </Checkbox>
      </div>

      {/* Query button */}
      <div className="flex gap-2">
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={onQuery}
          loading={loading}
          disabled={!check1 && !check2}
        >
          查詢
        </Button>
      </div>
    </div>
  );
};

export default React.memo(QueryParams);
